import React from 'react';

import Config from 'Config';
import { HeaderProps } from './Props';

import './header.less';


import { MaintenanceAlert } from './MaintenanceAlert';

export const Header: React.StatelessComponent<HeaderProps> = (props) => (
  <div className="nopad">
    <MaintenanceAlert></MaintenanceAlert>
    <div className="nopad" style={{ backgroundColor: 'white', zIndex: 1030, height: '130px', position: 'relative', border: '1px solid red-', pointerEvents: 'none' }}>

      <div id="div-fndry-header-topbar_holder" className="nopad-" style={{ position: 'relative', width: '100%', height: '34px', textAlign: 'right', backgroundColor: '#fafafa', pointerEvents: 'none', paddingRight: '20px' }}>
        <a href="https://foundry.shawhospitality.com/v4.14.30/FoundryTutorial.pdf" target="_blank">
          <span className="fndry-header-topbar" style={{ padding: '0px', paddingLeft: '0px', paddingRight: '5px' }}>Tutorials</span>
        </a>
        {
          props.authLinks.map((x, idx) => (
            (x.name !== 'Admin') ?
              <a href={x.url} target="_self">
                <span key={idx} className="fndry-header-topbar" style={{ padding: '0px', paddingLeft: '0px', paddingRight: '5px' }}> {x.name} </span>
              </a>
              :
              <a href={x.url} target="_self">
                <span key={idx} className="fndry-header-topbar" style={{ padding: '0px', paddingLeft: '0px', paddingRight: '5px' }}><b>{x.name}</b></span>
              </a>
          ))
        }

      </div>

      <div id="div-fndry-header-logo_holder" style={{ textAlign: 'left', pointerEvents: 'none', paddingLeft: '35px', pointEvents: 'none' }}>
        <a id="div-fndry-header-logo-a" href="https://www.shawcontract.com/en-US/Segments/Hospitality" target="_blank">
          <img id="div-fndry-header-logo" src="/Assets/Sites/Foundry/shg_header.png-" style={{ paddingLeft: '23px', width: '177px' }} />
        </a>
      </div>

      <div id="div-fndry-header-mainbar" style={{ position: 'absolute', left: '0px', top: '40px', width: '100%', textAlign: 'center', pointerEvents: 'none' }}>
        <div style={{ width: 'auto', pointerEvents: 'none' }}>

          <a href="/search" target="_self">
            <span className="fndry-header-mainbar">Designs</span>
          </a>

          {
            (Config.studio.showPomBox ?
              <a href="/pombox" target="_self">
                <span className="fndry-header-mainbar">Digital Pom Box</span>
              </a>
              : null)
          }

        </div>
      </div>

      <div id="div-fndry-header-icons" className="nopad" style={{ position: 'absolute', left: '0px', top: '43px', width: '100%', textAlign: 'right', paddingRight: '13px', pointerEvents: 'none' }}>

        <div style={{ width: 'auto' }}>

          {
            (!props.loading) ?
              (props.authLinks[0].name !== 'Register') ?
                <span id="spn-fndry-header-welcome" className="fndry-header-mainbar-welcome fndry-header-icons">
                  <span>
                    {props.account ? (
                      <span>Hi {props.account.contact.fullName.split(" ")[0]}&nbsp;</span>
                    ) : null}
                  </span>
                  <a href={props.authLinks[1].url} target="_self">
                    <i className="far fa-user-alt"></i>
                  </a>
                </span>
                :
                <a href={props.authLinks[1].url} target="_self">
                  <i className="far fa-user-alt fndry-header-icons"></i>
                </a>
              : null
          }

          <a href="/saved" target="_self">
            <i className="far fa-heart fndry-header-icons"></i>
          </a>

          <a href="/basket">
            <div className="fndry-notif-badge-holder" style={{ marginRight: '5px' }}>
              <i className="far fa-shopping-cart fndry-header-icons"></i>
              <span className="fndry-notif-badge" style={{ marginTop: '-35px', marginLeft: '32px' }}>{props.basketCount}</span>
            </div>
          </a>

          <a href="https://visualize.shawcontract.com/#/configurator" target="_blank" style={{ marginRight: '20px', verticalAlign: '-11px' }}>
            <div id="div-fndry-header-3d-icon" className="fndry-header-icons" style={{ display: 'inline', width: '19px', height: '19px' }}></div>
          </a>

        </div>

      </div>
    </div>
  </div>
);
